module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_3.cd8ef187.png";